
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCancelSend as ObiCancelSendElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cancel-send.js';
 
 
 

 
 export const ObiCancelSend = createComponent({
   react: React,
   tagName: 'obi-cancel-send',
   elementClass: ObiCancelSendElement,
   events: {
     
   }
  });
 
 